import get from 'lodash/get'
import PropTypes from 'prop-types'

import API from 'api'
import callPromiseWithRetry from 'common/utils/callPromisewithRetry'
import getCampaignBanner from 'common/utils/getCampaignBanner'
import globalRequest from 'common/utils/globalRequest'
import GenericPage from 'components/genericPage'
import AppLayout from 'layouts/AppLayout'


ImageFilterGridPage.propTypes = {
  pageData: PropTypes.object.isRequired,
}


export async function getServerSideProps({ locale, query }) {
  const requiredLocale = process.env.EXCLUDE_LOCALES.includes(locale) ? 'de' : locale
  const initialReduxStore = await globalRequest(requiredLocale)
  const callPageData = () => API.get('api/v1/pages/erfahrungen', { headers: { 'Accept-Language': requiredLocale } })
  const pageData = await callPromiseWithRetry(callPageData).catch(() => null)
  if(!pageData) {
    return { notFound: true }
  }
  if(pageData?.action === 'redirect') {
    return {
      redirect: {
        destination: `/${requiredLocale}${pageData.slug}`,
        statusCode: pageData?.is_permanent ? 301 : 302,
      },
    }
  }
  const experienceMasonry = pageData.content.find(i => i.type === 'experience_masonry_grid')
  if(experienceMasonry) {
    initialReduxStore.getExperiences = await API.get('api/v1/feefo/experiences', { headers: { 'Accept-Language': requiredLocale }, params: { kind: experienceMasonry.value.kind, parent_id: experienceMasonry.value.parent_id, offset: 0, limit: 3 } })
      .then(res => ({ data: res }))
      .catch(() => null)
  }
  const tagFilterGrid = pageData.content.find(i => i.type === 'tag_filter_grid')
  if(tagFilterGrid) {
    tagFilterGrid.value.initialTag = tagFilterGrid.value.columns.find(i => i.tag.slug === query?.tag)?.tag?.name || ''
  }
  const campaignBanner = getCampaignBanner({ slug: query.slug, homeSlug: get(initialReduxStore, 'cmsInfo.data.home_page_slugs.' + requiredLocale), banners: get(initialReduxStore, 'cmsInfo.data.campaign_banners') })
  return { props: { initialReduxStore: { ...initialReduxStore, ...campaignBanner }, pageData } }
}

export default function ImageFilterGridPage({ pageData }) {
  const isHeaderFooterEnabled = {
    isHeaderEnabled: get(pageData, 'display_header', true),
    isFooterEnabled: get(pageData, 'display_footer', true),
  }
  return (
    <AppLayout withCover {...isHeaderFooterEnabled}>
      <GenericPage data={pageData} />
    </AppLayout>
  )
}
